<template>
  <div class="programme">
    <div class="header">
      <div class="title">行业解决方案</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div
          class="item"
          v-for="item in leftList"
          :key="item.id"
          :class="item.id == listId ? 'active' : ''"
          @mouseenter="listEnter(item.id)"
        >
          <div v-if="item.id != listId">
            <div class="title">{{ item.title }}</div>
          </div>
          <div v-else>
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
            <router-link :to="item.path">
              <div class="more">
                <div>查看详情</div>
                <img :src="more" alt="" />
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="list">
          <div class="item" v-for="item in rightList" :key="item.id">
            <div class="box" v-if="item.id == listId">
              <div class="it" v-for="it in item.list" :key="it.id">
                <div class="title">{{ it.title }}</div>
                <div class="text">{{ it.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import programmeLogo from "../../../assets/programme/programmeLogo.png";
import more from "../../../assets/programme/more.png";

export default {
  setup() {
    return reactive({
      programmeLogo: programmeLogo,
      more: more,
      listId: 1,
      leftList: [
        {
          id: 1,
          title: "智慧社区",
          text: "全面的物业管理功能+IOT硬件对接",
          path: "/pc/programme/community",
        },
        {
          id: 2,
          title: "智慧物业",
          text: "聚焦物业管理，打造软硬一体化的物业管理",
          path: "/pc/programme/property",
        },
        {
          id: 3,
          title: "智慧后勤",
          text: "聚焦后勤管理场景，构建一体化管理平台",
          // path: "/pc/programme/logistics",
          path: '',
        },
        {
          id: 4,
          title: "社区管理",
          text: "多种AI算法，轻松搞定社区管理工作",
          path: "/pc/programme/communityadmin",
        },
      ],
      rightList: [
        {
          id: 1,
          list: [
            {
              id: 1,
              title: "物业基础服务数字化",
              text: "物业缴费、通知公告、报事报修、离线抄表等业务在线完成，实现移动办公",
            },
            {
              id: 2,
              title: "财务管理智能化",
              text: "自动生成财务凭证，财务快速对账，系统支持多维度报表统计，应收欠收等数据一目了然，财务管理更智能",
            },
            {
              id: 3,
              title: "业主生活便利化",
              text: "业主需求一键触达，物业急速响应，极大地提高了物业服务质量和用户满意度",
            },
            {
              id: 4,
              title: "社区生活智能化",
              text: "根据需求对接智能硬件设备，为业主带来智能化社区生活体验",
            },
            {
              id: 5,
              title: "移动办公效率化",
              text: "全员在线协同办公，帮助物业、居委、业委提高办公效率",
            },
            {
              id: 6,
              title: "社区流量商业变现",
              text: "社区商城支持多种营销方式，帮助物业快速实现商业变现",
            },
          ],
        },
        {
          id: 2,
          list: [
            {
              id: 1,
              title: "统一管理",
              text: "多个小区在同一系统统筹立体化管理，打破信息和数据孤岛，让管理分析更统一、更精确",
            },
            {
              id: 2,
              title: "员工管理",
              text: "任务标准统一化、工作流程规范化，多角色多权限自定义分配，员工外勤定位监控",
            },
            {
              id: 3,
              title: "智能安防",
              text: "通过小区摄像头视频流实现对小区安全的实时监控",
            },
            {
              id: 4,
              title: "设备管理",
              text: "多种设备集中管理，按周月等自由设置巡检/保养/维修周期，系统自定生成管理任务",
            },
            {
              id: 5,
              title: "智能门禁",
              text: "智能人脸识别开门、密码开门、二维码开门、访客邀约一键开门",
            },
            {
              id: 6,
              title: "在线报修",
              text: "业主一键报修，物业收到提醒即刻在线派单，员工快速上门解决，提高物业服务质量",
            },
          ],
        },
        {
          id: 3,
          list: [
            {
              id: 1,
              title: "资产物料数字化",
              text: "资产物料全面数字化、可视化资产图，提高经营收益",
            },
            {
              id: 2,
              title: "车辆管理智能化",
              text: "车辆档案、用车申请、用车审批、车辆维修保养",
            },
            {
              id: 3,
              title: "物业管理线上化",
              text: "报修工单、保洁绿化、设备管理、装修管理",
            },
            {
              id: 4,
              title: "安保管理全面化",
              text: "巡更巡检巡查、访客管理、门禁管理、安防监控",
            },
            {
              id: 5,
              title: "办公管理效率化",
              text: "考勤排版、会议管理、OA审批、党建管理",
            },
            {
              id: 6,
              title: "移动办公快速化",
              text: "移动办公、线上审批、离线巡检",
            },
          ],
        },
        {
          id: 4,
          list: [
            {
              id: 1,
              title: "垃圾治理",
              text: "自动识别乱扔垃圾现象，记录人脸，自动识别垃圾堆放程度",
            },
            {
              id: 2,
              title: "停车治理",
              text: "停车区域视频AI分析，智能识别乱停现象，记录车辆及车牌号",
            },
            {
              id: 3,
              title: "出入人员治理",
              text: "社区出入口视频监控，陌生人出入小区，门禁监控自动识别并发出警告",
            },
            {
              id: 4,
              title: "社区安全治理",
              text: "视频巡更，预警事件告警（周界入侵，高空抛物）",
            },
            {
              id: 5,
              title: "危险行为警告",
              text: "危险区域（湖边、行车道、电梯）重点监控危险行为，及时预警",
            },
            {
              id: 6,
              title: "重点人员监控",
              text: "查询重点人员在某段时间内的行为轨迹",
            },
          ],
        },
      ],
    });
  },
  methods: {
    listEnter(id) {
      this.listId = id;
    },
  },
};
</script>

<style scoped>
.programme {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}
.body {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.body .left {
  width: 280px;
  height: 400px;
  background-image: url(../../../assets/programme/programmeLogo.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.body .left .item {
  padding: 30px 40px 20px;
  color: #fff;
  cursor: pointer;
}
.body .left .active {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(30px);
}
.body .left .item .title {
  font-size: 18px;
}
.body .left .item .text {
  font-size: 12px;
  margin-top: 20px;
}
.body .left .item .more {
  display: flex;
  align-items: center;
  margin-top: 20px;
  color: #fff;
}
.body .left .item .more img {
  margin-left: 8px;
  height: 12px;
}

.body .right .list .item .box {
  width: 879px;
  display: flex;
  flex-wrap: wrap;
}
.body .right .list .item .box .it {
  height: 200px;
  padding: 0 30px;
  border: 1px solid rgba(213, 227, 250, 0.5);
  background: #fafbfe;
}
.body .right .list .item .box .it .title {
  font-size: 16px;
  margin-top: 30px;
}
.body .right .list .item .box .it .text {
  width: 230px;
  font-size: 14px;
  margin-top: 30px;
  color: #495a6c;
}
</style>
